<template>
  <span>
    <span
      v-for="chunk in chunks"
      :key="chunk.key"
      :class="{'font-weight-bold': shouldHighlight(chunk.match)}"
      data-test="chunk-text"
      v-text="chunk.text"
    />
  </span>
</template>

<script lang="ts">
import { defineComponent, toRefs } from 'vue'
import { useI18n } from '@src/composables/useI18n'
import useHighlightWords from './composables/useHighlightWords'

export default defineComponent({
  name: 'SMHighlightWords',
  props: {
    text: {
      type: String,
      required: true
    },
    query: {
      type: String,
      required: true
    },
    highlightNonMatches: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    const { t } = useI18n()
    const { text, query, highlightNonMatches } = toRefs(props)
    const { chunks } = useHighlightWords(text, query)

    function shouldHighlight(chunkMatch: boolean) {
      return (!highlightNonMatches.value && chunkMatch) || (highlightNonMatches.value && !chunkMatch)
    }

    return {
      t,
      chunks,
      shouldHighlight
    }
  }
})

</script>
